import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import '@platform-ui/highrise/style.css'
import './styles/tokens.css'
import './styles/app.css'
import './styles/ship.css'
import './styles/radar2.css'
import './styles/team2.css'
import './styles/docs-embed-fix.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

function mountApp(): void {
  app.mount('#app')
}

// Wait for route guards so the first paint is the final launch/login surface.
void router.isReady().then(mountApp, mountApp)
